import {useTranslation} from "react-i18next";


const useHighChartLocaleOptions = () => {
    const {t} = useTranslation('graphs');

    return {
        lang: {
            printChart: t("printChart"),
            downloadPNG: t("downloadPNG"),
            downloadJPEG: t("downloadJPEG"),
            downloadPDF: t("downloadPDF"),
            downloadSVG: t("downloadSVG"),
            downloadCSV: t("downloadCSV"),
            downloadXLS: t("downloadXLS"),
            viewData: t("viewData"),
            viewFullscreen: t("viewFullscreen"),
            exitFullscreen: t("exitFullscreen"),
            noData: t("noData")
        }
    }
}

export default useHighChartLocaleOptions;